<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Easter
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To understand that not everyone accepts Jesus as God's promised king.
                        </li>
                        <li>
                            To know that Jesus' sacrificial death was the only way that sin could be dealt with.
                        </li>
                        <li>
                            To teach that Jesus died in our place.
                        </li>
                        <li>
                            To understand how the resurrection proves that Jesus can be trusted in all things.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series follows the Passion narrative in Luke's Gospel and covers the week from Palm Sunday to Easter Sunday. It explores how a holy God made it possible for sinful people to enter his kingdom through the perfect sacrifice of Jesus on the cross.
                    </p>

                    <p>
                        In the first lesson we see Jesus being celebrated as king as he arrives in Jerusalem on Palm Sunday. The second lesson explores the connection between the Exodus Passover meal (the meal Jesus ate with his disciples on the night he was betrayed) and his imminent death. The third lesson deals with Jesus' trial and crucifixion. It teaches that innocent Jesus died in the place of guilty people to secure them a place in heaven. The final lesson shows how the historical, bodily resurrection proves that Jesus is entirely trustworthy.
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - The Triumphal Entry (Luke 19:28-40)
                    </p>
                    <p>
                        Lesson 2 - The Last Supper (Luke 22:7-23)
                    </p>
                    <p>
                        Lesson 3 - The Crucifixion (Luke 23:13-49)
                    </p>
                    <p>
                        Lesson 4 - The Resurrection (Luke 24:1-12)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Luke",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Luke`,
            meta: [
                {
                    name: 'description',
                    content: "To know that Jesus' sacrificial death was the only way that sin could be dealt with.",
                },
            ],
        };
    },
};
</script>
